<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.lstSchoolEventLangDTO"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].eventTitle`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.eventTitle"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">IDEAS Category</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="ideasCategory"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                  <el-select v-model="detailInfo.ideasCategory" clearable name="ideasCategory">
                    <el-option
                        v-for="item in [
                          { key: 'I', label: 'Innovation' },
                          { key: 'D', label: 'Discipline' },
                          { key: 'E', label: 'Exposure' },
                          { key: 'A', label: 'Adventure' },
                          { key: 'S', label: 'Synergy' },
                        ]"
                        :label="item.label"
                        :value="item.key"
                        :key="item.key"
                        class="ng-binding"
                      ></el-option>
                  </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event Start Date & Time
                </label>
                <div class="col-sm-10">
                  <div style="display: flex">
                    <el-form-item
                      prop="startEventDate"
                      style="width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-date-picker
                        v-model="startSubDate"
                        type="date"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                      prop="startEventDate"
                      style="margin-left: 20px; width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-time-picker
                        v-model="startSubTime"
                      >
                      </el-time-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event End Date & Time
                </label>
                <div class="col-sm-10">
                  <div style="display: flex">
                    <el-form-item
                      prop="endEventDate"
                      style="width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-date-picker
                        v-model="endSubDate"
                        type="date"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                      prop="endEventDate"
                      style="margin-left: 20px; width: 300px !important"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-time-picker
                        v-model="endSubTime"
                      >
                      </el-time-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Event District</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="eventDistrictCode"
                  >
                   <el-select
                      :disabled="userRole != 0"
                      v-model="detailInfo.eventDistrictCode"
                      v-bind:placeholder="$t('message.PleaseSelect')"
                      name="eventDistrictCode"
                      @change="getSchoolCodeList"
                    >
                      <el-option
                        v-for="item in districtGetlist"
                        :key="item.districtCode"
                        :label="item.districtNameEn"
                        :value="item.districtCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Event location </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].location`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.location"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Description </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstSchoolEventLangDTO[${index}].description`"  
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <ckeditor
                      :editor="editor"
                      @ready="editorOnReady"
                      v-model="langItem.description"
                      :config="editorConfig"
                    ></ckeditor>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Event Images (max. 5)
                </label>
                <div class="col-sm-10" style="display: flex">
                  <vuedraggable
                    v-model="detailInfo.lstSchoolEventImageDTO"
                    class="drag"
                  >
                    <transition-group>
                      <div
                        class="dragInfo"
                        v-for="item in detailInfo.lstSchoolEventImageDTO"
                        :key="item.eventImageUrl"
                      >
                        <el-image :src="item.showEventImageUrl"></el-image>
                        <i
                          class="el-icon-delete dragDelete"
                          @click="handleRemove(item)"
                        ></i>
                      </div>
                    </transition-group>
                  </vuedraggable>

                  <el-upload
                    action="#"
                    :http-request="uploadFile"
                    :file-list="detailInfo.lstSchoolEventImageDTO"
                    list-type="picture-card"
                    accept=".png, .jpg , .jpeg"
                    :auto-upload="true"
                    :show-file-list="false"
                  >
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.showEventImageUrl"
                        alt=""
                      />
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-delete"
                          @click="handleRemove(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <label class="col-sm-2 control-label"></label>
                <el-form-item
                    class="col-sm-10"
                    :prop="'imageListIsNull'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input
                      style="display:none"
                      v-model="detailInfo.imageListIsNull"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Remarks from SLO </label>
                <div class="col-sm-10">
                  <el-form-item prop="sloNote">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="detailInfo.sloNote"
                      :name="'sloNote'"
                    />
                  </el-form-item>
                </div>
              </div>
              <!--TODO-->
              <div class="form-group">
                <label class="col-sm-2 control-label"> School </label>
                <div class="col-sm-10">
                  <el-form-item prop="schoolCode"
                  :rules="[
                      {
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      filterable
                      v-model="detailInfo.schoolCode"
                    >
                      <el-option
                        v-for="item in schoolCodeList"
                        :key="item.schoolCode"
                        :label="item.schoolName"
                        :value="item.schoolCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">
                  No. of Students Requested
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="noOfStudents">
                    <el-input
                      style="width: 300px"
                      v-model="detailInfo.noOfStudents"
                      :name="'noOfStudents'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Contact Person </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="contactPersonName"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      style="width: 300px"
                      v-model="detailInfo.contactPersonName"
                      :name="'contactPersonName'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Phone number </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="contactPersonTel"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      style="width: 300px"
                      v-model="detailInfo.contactPersonTel"
                      :name="'contactPersonTel'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Email address </label>
                <div class="col-sm-10">
                  <el-form-item prop="contactPersonEmail">
                    <el-input
                      style="width: 300px"
                      v-model="detailInfo.contactPersonEmail"
                      :name="'contactPersonEmail'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <div>
                    <el-button @click="handleCopyTo" v-if="$route.query.id" style="float: left">Copy to</el-button>
                  </div>
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      v-if="
                        (checkPermission('SchoolEvent_LIST_EDIT') && $route.query.id) ||
                        (checkPermission('SchoolEvent_LIST_ADD') && !$route.query.id)
                      "
                      >{{$route.query.id?'Save':'Add'}}</el-button
                    >
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import vuedraggable from "vuedraggable";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        eventTitle: "",
        ideasCategory: '',
        startEventDate: "",
        endEventDate: "",
        eventDistrictCode: '',
        eventLocation: "",
        description: "",
        message: "",
        schoolCode: "",
        noOfStudents: "",
        contactPersonName: "",
        contactPersonTel: "",
        contactPersonEmail: "",
        lstSchoolEventImageDTO: [],
        lstSchoolEventLangDTO: [],
        imageListIsNull:"No",
        sloNote:''
      },
      schoolCodeList: [],
      districtGetlist: [],
      editor: ClassicEditor,
      startSubDate: "",
      startSubTime: "",
      endSubDate: "",
      endSubTime: "",
      uploadErr:false
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
    editorConfig() {
      return {
        toolbar: [
          "Heading",
          "bold",
          "italic",
          "underline",
          "Link",
          "bulletedList",
          "numberedList",
          "fontfamily",
          "fontsize",
          "alignment",
          "outdent",
          "indent",
          "undo",
          "redo",
        ],
      };
    },
    userRole(){
      const res =JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType
    },
    userDistrictCode(){
      const res =JSON.parse(sessionStorage.getItem("userInfo"));
      return res.userDistrictCode
    }
  },
  watch: {
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
    startSubDate: {
      handler: function (e) {
        this.handleChangeDate(e, 'start')
      },
      deep: true,
    },
    startSubTime: {
      handler: function (e) {
        this.handleChangeDate(e, 'start')
      },
      deep: true,
    },
    endSubDate: {
      handler: function (e) {
        this.handleChangeDate(e, 'end')
      },
      deep: true,
    },
    endSubTime: {
      handler: function (e) {
        this.handleChangeDate(e, 'end')
      },
      deep: true,
    },
  },
  created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
        description: "",
      });
    }
    this.$set(this.detailInfo, "lstSchoolEventLangDTO", obj);
    this.getDistrictGetlist();
    
    this.init();
  },
  mounted() {
    if(this.userRole != 0 ){
      this.detailInfo.eventDistrictCode = this.userDistrictCode
    }
    this.getSchoolCodeList();
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      const eventRequestparams = this.$route.query.eventRequestparams;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = '/schoolEventRequest/getConfirmedEvent';
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if(data.data.result.isAllYearEvent){
          data.data.result.isAllYearEvent =
            data.data.result.isAllYearEvent.toString();
        }
        
        this.detailInfo = data.data.result;
        this.detailInfo.lstSchoolEventImageDTO.length?this.detailInfo.imageListIsNull = "No":''
        const startTime = this.$dayjs(this.detailInfo.startEventDate)
        const endTime = this.$dayjs(this.detailInfo.endEventDate)
        this.startSubDate=this.detailInfo.startEventDate?startTime.toDate():''
        this.startSubTime=this.detailInfo.startEventDate?startTime.toDate():''
        this.endSubDate=this.detailInfo.endEventDate?endTime.toDate():''
        this.endSubTime=this.detailInfo.endEventDate?endTime.toDate():''

      } else if (eventRequestparams) {
        this.detailInfo = Object.assign(this.detailInfo, eventRequestparams);
        const startTime = this.$dayjs(this.detailInfo.startEventDate)
        const endTime = this.$dayjs(this.detailInfo.endEventDate)
        this.startSubDate=this.detailInfo.startEventDate?startTime.toDate():''
        this.startSubTime=this.detailInfo.startEventDate?startTime.toDate():''
        this.endSubDate=this.detailInfo.endEventDate?endTime.toDate():''
        this.endSubTime=this.detailInfo.endEventDate?endTime.toDate():''
        
      } else {
        //TODO
      }
      setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
    },
    editorOnReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    checkEvent: function () {
      if(this.detailInfo.lstSchoolEventImageDTO.length) this.detailInfo.imageListIsNull = "No"
      else this.detailInfo.imageListIsNull = ""
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleRemove(file) {
      var index = "";
      this.detailInfo.lstSchoolEventImageDTO.forEach((item, i) => {
        if (item.eventImageUrl == file.eventImageUrl) {
          index = i;
        }
      });
      this.detailInfo.lstSchoolEventImageDTO.splice(index, 1);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async getSchoolCodeList(){
      let obj = this.getAuthObj();
        obj.pageSize=99999
        obj.pageIndex=1
        obj.districtCode = this.detailInfo.eventDistrictCode
        obj.apiUrl = '/school/list';
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        const res = this.$lodash.orderBy(data.data.result.schools,'schoolName','asc')
        this.schoolCodeList = res
    },
    async getDistrictGetlist() {
        let obj = this.getAuthObj();
        obj.apiUrl = this.apiConfig.districtGetlist;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        this.$set(this, "districtGetlist", data.data.result);
      },
    async submit() {
      try {
        let obj = this.getAuthObj();
        delete this.detailInfo.imageListIsNull
        delete this.detailInfo.status
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        var data;
        if (this.$route.query.id) {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.id = this.$route.query.id;
          obj.apiUrl = '/schoolEventRequest/updateConfirmedEvent';
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.apiUrl = '/schoolEventRequest/addConfirmedEvent';
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
      this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.detailInfo.lstSchoolEventImageDTO.push({
        eventImageUrl: data.data.result.url,
        showEventImageUrl: data.data.result.showUrl,
        fileType: 1,
        sortOrder: 1,
      });
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {},
    handleChangeDate(e, type) {

      if(this[`${type}SubDate`] instanceof Date && isNaN(this[`${type}SubDate`].getTime())) this[`${type}SubDate`]=''
      if(this[`${type}SubTime`] instanceof Date && isNaN(this[`${type}SubTime`].getTime())) this[`${type}SubTime`]=''
      if(!(this[`${type}SubDate`]&&this[`${type}SubTime`])) return this.detailInfo[`${type}EventDate`]=''
      const date = this.$dayjs(this[`${type}SubDate`]).format(
        "YYYY-MM-DD"
      );
      const time = this.$dayjs(this[`${type}SubTime`]).format(
        "HH:mm:ss"
      );
      this.detailInfo[`${type}EventDate`] = `${date} ${time}`;
    },
    handleCopyTo(){
      this.$route.query.id=""
      this.detailInfo ={
        eventTitle: this.detailInfo.eventTitle,
        ideasCategory: this.detailInfo.ideasCategory,
        startEventDate: this.detailInfo.startEventDate,
        endEventDate: this.detailInfo.endEventDate,
        eventDistrictCode: this.detailInfo.eventDistrictCode,
        eventLocation: this.detailInfo.eventLocation,
        description: this.detailInfo.description,
        message: this.detailInfo.message,
        schoolCode: this.detailInfo.schoolCode,
        noOfStudents: this.detailInfo.noOfStudents,
        contactPersonName: this.detailInfo.contactPersonName,
        contactPersonTel: this.detailInfo.contactPersonTel,
        contactPersonEmail: this.detailInfo.contactPersonEmail,
        lstSchoolEventImageDTO: this.detailInfo.lstSchoolEventImageDTO,
        lstSchoolEventLangDTO: this.detailInfo.lstSchoolEventLangDTO,
        imageListIsNull:this.detailInfo.imageListIsNull,
        sloNote:this.detailInfo.sloNote
      }
      this.$forceUpdate()
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
  components: { vuedraggable },
};
</script>
